import React, {FC, useMemo} from 'react';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {getProductCanonSection} from 'modules/product-card/helpers';

export const FlocktoryItemView: FC = () => {
    const product = useAppSelector(selectProductData);

    const data = useMemo(() => {
        if (!product) {
            return null;
        }

        const {offerId, brand, canBuy, canReserve, sections} = product;
        const category = getProductCanonSection(sections);

        return {
            offerId,
            categoryId: category?.id ?? 0,
            vendor: brand?.title,
            available: Boolean(canBuy || canReserve),
        };
    }, [product]);

    if (!data?.offerId) {
        return null;
    }

    return (
        <div
            className={'i-flocktory'}
            data-fl-action={'track-item-view'}
            data-fl-item-id={String(data.offerId)}
            data-fl-item-category_id={data.categoryId}
            data-fl-item-vendor={data.vendor || undefined}
            data-fl-item-available={String(Boolean(data.available))}
        />
    );
};

export default FlocktoryItemView;
